module.exports = {
	"line-chart": {
		"labels": [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July"
		],
		"datasets": [
			{
				"label": "My First dataset",
				"fillColor": "rgba(220,220,220,0.2)",
				"strokeColor": "rgba(220,220,220,1)",
				"pointColor": "rgba(220,220,220,1)",
				"pointStrokeColor": "#fff",
				"pointHighlightFill": "#fff",
				"pointHighlightStroke": "rgba(220,220,220,1)",
				"data": [
					65,
					59,
					80,
					81,
					56,
					55,
					40
				]
			},
			{
				"label": "My Second dataset",
				"fillColor": "rgba(151,187,205,0.2)",
				"strokeColor": "rgba(151,187,205,1)",
				"pointColor": "rgba(151,187,205,1)",
				"pointStrokeColor": "#fff",
				"pointHighlightFill": "#fff",
				"pointHighlightStroke": "rgba(151,187,205,1)",
				"data": [
					28,
					48,
					40,
					19,
					86,
					27,
					90
				]
			}
		]
	},
	"radar-chart": {
		"labels": [
			"Eating",
			"Drinking",
			"Sleeping",
			"Designing",
			"Coding",
			"Cycling",
			"Running"
		],
		"datasets": [
			{
				"label": "My First dataset",
				"fillColor": "rgba(220,220,220,0.2)",
				"strokeColor": "rgba(220,220,220,1)",
				"pointColor": "rgba(220,220,220,1)",
				"pointStrokeColor": "#fff",
				"pointHighlightFill": "#fff",
				"pointHighlightStroke": "rgba(220,220,220,1)",
				"data": [
					65,
					59,
					90,
					81,
					56,
					55,
					40
				]
			},
			{
				"label": "My Second dataset",
				"fillColor": "rgba(151,187,205,0.2)",
				"strokeColor": "rgba(151,187,205,1)",
				"pointColor": "rgba(151,187,205,1)",
				"pointStrokeColor": "#fff",
				"pointHighlightFill": "#fff",
				"pointHighlightStroke": "rgba(151,187,205,1)",
				"data": [
					28,
					48,
					40,
					19,
					96,
					27,
					100
				]
			}
		]
	},
	"polar-chart": {
		"datasets": [
			{
				"data": [
					11,
					16,
					7,
					3,
					14
				],
				"backgroundColor": [
					"#FF6384",
					"#4BC0C0",
					"#FFCE56",
					"#E7E9ED",
					"#36A2EB"
				],
				"label": "My dataset"
			}
		],
		"labels": [
			"Red",
			"Green",
			"Yellow",
			"Grey",
			"Blue"
		]
	},
	"bar-chart": {
		"labels": [
			"January",
			"February",
			"March",
			"April",
			"May",
			"June",
			"July"
		],
		"datasets": [
			{
				"label": "My First dataset",
				"fillColor": "rgba(220,220,220,0.5)",
				"strokeColor": "rgba(220,220,220,0.8)",
				"highlightFill": "rgba(220,220,220,0.75)",
				"highlightStroke": "rgba(220,220,220,1)",
				"data": [
					65,
					59,
					80,
					81,
					56,
					55,
					40
				]
			},
			{
				"label": "My Second dataset",
				"fillColor": "rgba(151,187,205,0.5)",
				"strokeColor": "rgba(151,187,205,0.8)",
				"highlightFill": "rgba(151,187,205,0.75)",
				"highlightStroke": "rgba(151,187,205,1)",
				"data": [
					28,
					48,
					40,
					19,
					86,
					27,
					90
				]
			}
		]
	},
	"doughnut-chart": {
		"labels": [
			"Camels",
			"Fish",
			"Startups",
			"Real Estate",
			"Cash",
			"Loans",
			"Bonds",
			"Stocks",
			"Comodities"
		],
		"datasets": [
			{
				"data": [
					300,
					50,
					100,
					100,
					50,
					50,
					50,
					50,
					50
				],
				"backgroundColor": [
					"#4D4D4D",
					"#5DA5DA",
					"#FAA43A",
					"#60BD68",
					"#F17CB0",
					"#B2912F",
					"#B276B2",
					"#DECF3F",
					"#F15854"
				],
				"hoverBackgroundColor": [
					"#4D4D4D",
					"#5DA5DA",
					"#FAA43A",
					"#60BD68",
					"#F17CB0",
					"#B2912F",
					"#B276B2",
					"#DECF3F",
					"#F15854"
				]
			}
		]
	},
	"pie-chart": {
		"labels": [
			"Red",
			"Blue",
			"Yellow"
		],
		"datasets": [
			{
				"data": [
					300,
					50,
					100
				],
				"backgroundColor": [
					"#FF6384",
					"#36A2EB",
					"#FFCE56"
				],
				"hoverBackgroundColor": [
					"#FF6384",
					"#36A2EB",
					"#FFCE56"
				]
			}
		]
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/chartjs/chartjs.json
 ** module id = 439
 ** module chunks = 0
 **/